import {Component, ElementRef, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DbServerErrors} from "../../../shared/interceptors/db-server-errors";
import {HostingService} from "../../website/hosting/hosting.service";
import {DbResponse} from "../../../shared/interceptors/db-response";
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable} from 'rxjs';
import {ActivityAction, IActivity} from "../../../activities/activity";
import {Utils} from "../../../shared/utils/utils";
import {TypeUtils} from "../../../shared/utils/type-utils";
import {DbValidators} from "../../../shared/validators/DbValidators";
import {IFcDropdownSelectOption} from "../../../shared/components/form-controls/dropdown-select/fc-dropdown-select-option";
import {Config} from "../../../config/config";
import {Website} from "../../website/website";
import {UserSubscription, UserSubscriptionIds, UserSubscriptionType} from "../../../user/user-subscription";
import {filter, first, switchMap} from "rxjs/operators";
import {User} from "../../../user/user";
import {Router} from "@angular/router";
import {RouteDataService} from "../../../shared/services/route-data/route-data.service";
import {RouteData} from "../../../shared/services/route-data/route-data";
import {Product} from "../../website/product";
import {TypeFormAnswers} from "../../../add-website/typeFormAnswers";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {
  NotificationDialogComponent
} from "../../../shared/components/dialogs/notification-dialog/notification-dialog.component";
import {TextUtils} from "../../../shared/utils/text-utils";
import {PaymentDialogComponent} from "../../../workspace/billing/payment-dialog/payment-dialog.component";

@Component({
    selector: 'db-website-install-trial-flow',
    templateUrl: 'website-install-trial-flow.component.html',
    styleUrls: ['website-install-trial-flow.component.scss'],
    standalone: false
})
export class WebsiteInstallTrialFlowComponent implements OnInit {

  @Output() closeDialog = new EventEmitter<any>();
  @Output() showComponent: EventEmitter<any>;
  @Output() _hideCloseButton: EventEmitter<any>;
  @Output() blocker = new EventEmitter<any>();
  @Input() upgradeAvailable: boolean;
  @Input() currentSubscription: UserSubscription;
  @Input() componentDataMap: any;
  @Input() userId: string;
  @Input() showBackButton?: boolean = true;
  @Input() _blocker?: any;
  @Input() forceCreateWebsite?: boolean;
  @Input() _region?: any;
  @Input() dialogTitle?: any;
  @Input() buttonLabel?: any;
  @Input() migrateDialog?: any;
  @Input() insidePageContent?: any;
  @Input() hostingsLimit: any;
  @Input() hostedWebsitesCount?: any = 0;
  @Input() dialogDesc?: any;
  @Input() userLocalStorage?: any;
  @Output() width = new EventEmitter<any>();
  @Output() height = new EventEmitter<any>();

  public hasServerFieldErrors: boolean;
  public configHostname: string = Config.hostname;
  public wordpressInstallationForm: FormGroup;
  public formSubmitted: boolean;
  public loading: boolean;
  public loadingContent: boolean;
  public serverErrors: DbServerErrors;
  public serverErrorsMessage: string;
  public region: FormControl;
  public ongoingActivity$: Observable<IActivity>;
  public showPassword: boolean = false;
  public regionOptions: IFcDropdownSelectOption[];
  public filteredWebsites: Website[];
  public isCopiedWpPassword: boolean;
  public user: User;
  public isPlatformTrialUser: boolean;
  public UserSubscriptionIds: any = UserSubscriptionIds;
  public isMobile: boolean;
  public routeData: RouteData;
  public steps: any;
  public createWbsiteActivity$: Observable<IActivity>;
  public step3: any;
  public UserSubscriptionType: any = UserSubscriptionType;
  public agencyOrFreelancer: boolean;
  private typeFormAnswers = TypeFormAnswers;

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _hostingService: HostingService,
    private el: ElementRef,
    private _router: Router,
    private _routeDataService: RouteDataService,
    private _dialogService: DialogService,
  ) {
    this.showComponent = new EventEmitter<any>();
    this._hideCloseButton = new EventEmitter<any>();
    this.width = new EventEmitter<any>();
  }


  ngOnInit () {
    if (window.innerWidth < 991) {
      this.isMobile = true;
    }
    this.routeData = this._routeDataService.getCurrentRouteData();
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUser))
      )
      .subscribe(user => {
        this.user = user;
        this.getRegions();
        // this.isPlatformTrialUser = this.user && this.user.planType === UserSubscriptionType.FREE && this.user.hasHostingTrial;
        this.agencyOrFreelancer = user.agencyOrFreelancer;
      });
    this.getHostName();
    this.showBackButton = TypeUtils.isDefined(this.showBackButton) ? this.showBackButton : true;
    this._store.select(fromStore.getWebsitesLoaded)
      .pipe(
        filter((websitesLoaded: boolean) => websitesLoaded),
        switchMap(() => this._store.select(fromStore.getHostedWebsites))
      )
      .subscribe((websites: Website[]) => {
        this.filteredWebsites = websites.filter(website => website.type === 'live');
      });

    this.blocker.emit(false);
    this.showComponent.emit('website-install-trial-flow');
    this.region = new FormControl("");
    this.regionOptions = [];

    this.wordpressInstallationForm = new FormGroup({
      'subdomain': new FormControl("", [DbValidators.trim, Validators.required, Validators.pattern('^([a-z0-9]+(-[a-z0-9]+)*)$')]),
      'region': this.region,
      'siteTitle': new FormControl("My Website", [DbValidators.trimStart, Validators.required]),
      'admin_username': new FormControl("", [DbValidators.trimStart, Validators.required, Validators.pattern('^[A-za-z\\d\\-_*.@\\s]+$')]),
      'adminPassword': new FormControl("", [Validators.required, DbValidators.trim, Validators.pattern('^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])[\\w~@#$%^&*+=`|{}:;!.?()\\[\\]-]{8,}$')]),
    });
    this.loadingContent = true;
    this.getRegions();
    if (!this.wordpressInstallationForm.controls['subdomain'].value) {
      this.getSubdomainSuggestion();
    }
    this.ongoingActivity$ = this._store.select(fromStore.getCreateWebsiteOngoingActivity);
    this.ongoingActivity$.subscribe((activity) => {
      if (this.currentSubscription.subscriptionId === this.UserSubscriptionIds.TRIAL) {
        if (activity && activity.status === 'running') {
          this.loading = true;
          this.loadingContent = false;
          this.width.emit('680px');
          this.height.emit('327px');
          this._hideCloseButton.emit(true);
        }
        else if ((!activity  || (activity && activity.status === 'done')) && this.routeData.data.pageId === 'add-website') {
          this._store.dispatch( new fromStore.LoadWebsites() );
          this._store.dispatch( new fromStore.LoadUser() );
          let filteredWebsites: any[];
          filteredWebsites = this.filteredWebsites.filter((website: Website) => website.type === 'live');

          if (filteredWebsites && filteredWebsites.length && this.user.websiteCreated === 0 && (this.user.websiteConnected === 0 || !this.user.websiteConnected) && !localStorage.getItem('onboardingFlow')) {
            this.loadingContent = true;
            this.closeDialog.emit("true");
            this.updateSpeedOptimizer(filteredWebsites[0].id);

            if (TypeUtils.isDefined(this.insidePageContent)) {
              this.insidePage(filteredWebsites[0].id);
            }
            else {
              this._router.navigate(['/websites/' + filteredWebsites[0].id + '/onboarding']);
            }

          }
        }

        if (!activity && this.loading && !this.loadingContent) {
          this.step3 = 'done';
          this.componentDataMap['success'] = activity.meta;
          this.showComponent.emit('website-action-success');
        }
      }
    });
    this.formSubmitted = false;
    if (this.componentDataMap["website-install-trial-flow"]) {
      this.wordpressInstallationForm.setValue(this.componentDataMap["website-install-trial-flow"]);
    }
    if (!this.user.hostingTrialExpired && this.filteredWebsites && this.filteredWebsites.length >= this.hostingsLimit && this.user && this.user.subscriptionId === this.UserSubscriptionIds.TRIAL) {
      this.width.emit('500px');
    }
    if (this.forceCreateWebsite && this._region) {
      const websiteData = {
        siteTitle: this.wordpressInstallationForm && this.wordpressInstallationForm.controls['subdomain'].value || 'My Website',
        region: this._region
      };
      this.createWbsiteActivity$ = this._store.select(fromStore.getCreateWebsiteOngoingActivity);
      this.createWebsiteAutomatically(websiteData);
    }
  }

  public getHostName(): void {
    this._hostingService.getUserMainDomain()
      .pipe(filter((response: DbResponse) => !!response),
      first())
      .subscribe((response: DbResponse) => {
        if (response.success) {
          this.configHostname = response.data.domain;
        }
      });
  }

  public copiedWpPassword() {
    this.isCopiedWpPassword = true;
    setTimeout( () => this.isCopiedWpPassword = false, 800);
  }


  public trimValue (el): void {
    el.value = Utils.trimValue(el.value);
  }

  public onFormSubmit(): void {
    this.formSubmitted = true;

    if (this.currentSubscription && this.user && !this.user.oneProductOrBundleClient && this.currentSubscription.plan && this.currentSubscription.plan.services
      && this.filteredWebsites.length >= this.hostingsLimit) {
      return this.showExceededDialog();
    }

    if (this.wordpressInstallationForm.controls['siteTitle'].valid) {
      this.loading = true;
      this.loadingContent = false;
      this.serverErrors = null;
      this.hasServerFieldErrors = false;
      const websiteData = this.wordpressInstallationForm.value;
      this._hideCloseButton.emit(true);
      this.width.emit('680px');
      this.height.emit('327px');
      // if ( this.isPlatformTrialUser ) {


        this.createHostedWebsiteForTrialUsers(websiteData, true);

      // }
      /*else {
        this.createHostedWebsite(websiteData);
      }*/
    }
    else {
      const invalidControl = this.el && this.el.nativeElement && this.el.nativeElement.querySelector('.db-fc-input.ng-invalid');
      if (invalidControl) {
        invalidControl.focus();
      }
    }
  }
  /* submit on enter key press */
  keyDownFunction(event) {
    if (event.keyCode === 13) {
      this.onFormSubmit();
    }
  }

  public insidePage(id): void {
    this._store.dispatch(new fromStore.LoadWebsites());
    this._store.dispatch(new fromStore.LoadUser());
    this.loadingContent = true;
    if (this.user && this.user.signUpFor && this.user.signUpFor.CreationOption && this.user.signUpFor.CreationOption.id) {
      localStorage.setItem('dbOnboardingPassed' + this.user.id, '1');
      switch (this.user.signUpFor.CreationOption.id) {
        case this.typeFormAnswers.DESIGNER_MADE_TEMPLATE:
          this._router.navigate(['/websites/' + id + '/onboarding/onboarding-templates']);
          break;

        case this.typeFormAnswers.BUILD_WITH_TENWEB_IO:
          this._router.navigate(['/websites/' + id + '/onboarding/onboarding-recreate-website']);
          break;

        default:
          this._router.navigate(['/websites/' + id + '/plugins'], {queryParams: {fromOnboarding: true}});
      }
    }
  }

  public createHostedWebsiteForTrialUsers(websiteData, formSubmitted?: boolean): void {
    const demoUser = Utils.isDemoUser(this.currentSubscription, this.user);
    this._hostingService.createWebsiteForTrialUsers(websiteData, demoUser)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        this.step3 = 'done';
        setTimeout(() => {
          if (response.success) {
            if ( (this.user && (this.user.isSuspected || (this.user.hasHostingTrial && !this.user.hostingTrialExpired && response.data && response.data.domain_id)))) {
              this._hostingService.whiteListIp(response.data.domain_id, response.data.site_url);
            }
            TypeUtils.isDefined(this.insidePageContent) && this.insidePage(response.data.domain_id);

            this.componentDataMap['success'] = response.data;
            if (formSubmitted) {
              if (this.currentSubscription.subscriptionId === this.UserSubscriptionIds.TRIAL && this.user.websiteCreated === 0 && (this.user.websiteConnected === 0 || !this.user.websiteConnected) && !localStorage.getItem('onboardingFlow')) {
                this.closeDialog.emit("true");
                this._store.dispatch(new fromStore.LoadWebsites());
                this._store.dispatch( new fromStore.LoadUser() );
                this._router.navigate(['/websites/' + response.data.domain_id + '/onboarding']);
              } else {
                this.showComponent.emit('website-action-success');
              }
            }
            this.updateSpeedOptimizer(response.data.domain_id);
            this.loadingContent = true;
            this.loading = false;
          } else {
            this.loadingContent = false;
            this.loading = false;
            this.hasServerFieldErrors = !TypeUtils.isEmpty(response.serverErrors.fields);
            this.serverErrorsMessage = response.message;
          }
          this._hideCloseButton.emit(false);
        }, 1000);
      });
  }

  public createHostedWebsite(websiteData): void {
    this._hostingService.createWebsite(websiteData)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        this.loading = false;
        if (response.success) {
          this.componentDataMap['success'] = response.data;
          this.showComponent.emit('website-action-success');
          this.loadingContent = true;
        }
        else {
          this.loadingContent = true;
          this.hasServerFieldErrors = !TypeUtils.isEmpty(response.serverErrors.fields);
          this.serverErrors = response.serverErrors ? response.serverErrors : response.response ? response.response['error'] : "";
        }
        this._hideCloseButton.emit(false);
      });
  }

  public getSubdomainSuggestion() {
    this._hostingService.subdomainSuggestion()
      .pipe(filter((response: DbResponse) => !!response),
      first())
      .subscribe((response: DbResponse) => {
        if (response.success) {
          this.wordpressInstallationForm.controls["subdomain"].setValue(response.data.subdomain.toLowerCase());
          if (this.wordpressInstallationForm.controls["region"].value !== "" ) {
            this.loadingContent = false;
          }
        }
      });
  }

  public getRegions() {
    if (this.user) {
      this._hostingService.regions(this.user.subscriptionId).pipe(
        filter((response: DbResponse) => !!response),
        first())
        .subscribe((response: DbResponse) => {
          if (response.success) {
            this.regionOptions = response.data;
            const regionsFormatted = [];
            Object.keys(this.regionOptions).forEach((key: string): void => {
              regionsFormatted.push({
                label: this.regionOptions[key].location,
                value: this.regionOptions[key].zone,
                isAvailable: this.regionOptions[key].is_available
              });
            });
            this.regionOptions = regionsFormatted;
            if (this.regionOptions && this.regionOptions.length) {
              const region = this.regionOptions.find(_region => _region.isAvailable);
              this.region.setValue(region && region.value);
            }
            if (this.wordpressInstallationForm.controls["subdomain"].value !== "" || this.insidePageContent ) {
              this.loadingContent = false;
            }
          }
        });
    }
  }

  public togglePassword() {
    this.showPassword = !this.showPassword;
  }

  public back() {
    this.componentDataMap["website-install-trial-flow"] = this.wordpressInstallationForm.value;
    this.showComponent.emit(this.currentSubscription && this.currentSubscription.trialClient ? 'add-website-choice-activation-flow' : 'add-website-choice');
  }

  public generateRandomPassword() {
    const randomPassword = Utils.generateRandomPassword(12);
    this.wordpressInstallationForm.controls["adminPassword"].setValue(randomPassword);
  }

  public createWebsiteAutomatically(websiteData) {
    this.loading = true;
    this.loadingContent = false;
    this.serverErrors = null;
    this.hasServerFieldErrors = false;
    this._hideCloseButton.emit(true);

    this.createHostedWebsiteForTrialUsers(websiteData);
  }

  private updateSpeedOptimizer(websiteId) {
    this._store.select(fromStore.getWebsitePluginsLoaded(websiteId))
      .pipe(
        filter((loaded: boolean) => loaded),
        first()
      )
      .subscribe(() => {
        this._store.select(fromStore.getWebsiteOptimizerPlugin(websiteId))
          .pipe(first())
          .subscribe((speedOptimizerPlugin: Product) => {
            if (speedOptimizerPlugin && speedOptimizerPlugin.updateAvailable) {
              this._store.dispatch(new fromStore.InitWebsiteProductAction({
                website: websiteId,
                products: [speedOptimizerPlugin],
                action: ActivityAction.UPDATE,
                network: 1
              }));
            }
          });

      });
  }

  private showExceededDialog() {
    const exceededDesc = 'text_domainsExceededUpgradeToPaid';
    const exceededBtnText = "text_upgrade";
    const exceededBtnColor = "green";
    const action = "upgrade";
    this._dialogService.addDialog(NotificationDialogComponent, {
      header: TextUtils.getText('text_domainsExceededTitleDialog'),
      message: TextUtils.getText(exceededDesc),
      buttonText: TextUtils.getText(exceededBtnText),
      buttonColor: exceededBtnColor,
      action: action,
      hasCloseButton: true
    })
      .subscribe((confirmed: string): void => {
        if (confirmed) {
          if (confirmed === 'upgrade') {
            this._router.navigate(['/upgrade-plan']);
          }
          else if (confirmed === 'buyNow') {
            this._dialogService
              .addDialog(PaymentDialogComponent, {
                upgradeSubscription: this.currentSubscription,
                fromDialog: true,
                showAdditional: true
              });
          }
        }
      });
    this.closeDialog.emit("true");
  }

}
